module.exports = __webpack_public_path__ + "img/cx.b8ca263b.png";